<template>
  <div>
    <div
      class="field-error"
      v-if="validateOptions.$error === true && validateOptions.required === false "
    >此为必填项</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.minLength!=='undefined' && !validateOptions.minLength "
    >至少要有 {{validateOptions.$params.minLength.min}} 个字符</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.maxLength!=='undefined' && !validateOptions.maxLength "
    >不能超过 {{validateOptions.$params.maxLength.max}} 个字符</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.between!=='undefined' && !validateOptions.between "
    >数值必须在 {{validateOptions.$params.between.min}} 与 {{validateOptions.$params.between.max}} 之间</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.email!=='undefined' && !validateOptions.email "
    >邮件格式无效</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.minValue!=='undefined' && !validateOptions.minValue "
    >数值不能小于 {{validateOptions.$params.minValue.min}}</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.maxValue!=='undefined' && !validateOptions.maxValue "
    >数值不能大于 {{validateOptions.$params.maxValue.max}}</div>
    <div
      class="field-error"
      v-if="typeof validateOptions.numeric!=='undefined' && !validateOptions.numeric "
    >不是有效的数值</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.number!=='undefined' && !validateOptions.number "
    >不是有效的数值</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.integer!=='undefined' && !validateOptions.integer "
    >必须是整数类型</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.decimal!=='undefined' && !validateOptions.decimal "
    >必须是带小数类型</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.isMobile!=='undefined' && !validateOptions.isMobile "
    >不是有效的手机号</div>

    <div
      class="field-error"
      v-if="typeof validateOptions.requiredWhenValueNotEquals!=='undefined' && !validateOptions.requiredWhenValueNotEquals "
    >此为必填项</div>
    
    <div
      class="field-error"
      v-if="typeof validateOptions.isPhone!=='undefined' && !validateOptions.isPhone "
    >号码格式不正确</div>
  </div>
</template>
<script>
export default {
  name: "validator-prompt",
  props: {
    validateOptions: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: false
    }
  },
  created() {
    // console.log('create validator-prompt')
    // console.log(this.validateOptions)
  }
};
</script>

